import StringHelper from '../helpers/string-helper';
var NumberFormatter = /** @class */ (function () {
    function NumberFormatter() {
    }
    NumberFormatter.format = function (value, digits, thousandSeparator, decimalSeparator) {
        if (digits === void 0) { digits = 2; }
        if (thousandSeparator === void 0) { thousandSeparator = ' '; }
        if (decimalSeparator === void 0) { decimalSeparator = '.'; }
        if (!value) {
            return 0;
        }
        var formatted = StringHelper.parseInt(value)
            .toFixed(digits)
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1" + thousandSeparator);
        if (digits > 0) {
            return formatted.replace(/\.?0+$/, '');
        }
        return formatted;
    };
    return NumberFormatter;
}());
export default NumberFormatter;
